'use strict';

var _ = require('lodash');
var base = require('../common/base-url');
var bindTextInputs = require('../common/bind-text-inputs');
var disableBackButton = require('../common/disable-back-button.js');
var disableMultipleSubmit = require('../common/disable-multiple-submit.js');
var enableExpansion = require('./field-expander.js');
var onBonusTab = require('../common/detect-multiple-tabs.js');
var onMinutesAFK = require('../common/detect-extreme-afk.js');
var phone_utils = require('../common/phone-utils');
var validate_cb_1ormore = require('../common/validate-checkables-atleastone');
var validate_textfield = require('../common/validate-textfield');
var validateEmail = require('../common/validate-email');
var validatePhoneNumber = require('../common/validate-phonenumber');

require('../../../admin/assets/js/libs/cookieconsent.min');

var dietaryPrefs = require('./toggleDietaryPrefs.js');
var invoice = require('./invoice');
var partyMembers = require('./partyMembers');
var selections = require('./selections');

var toggleRetired = require('./toggleRetired.js');
var toggleChildFields = require('./toggleChildFields.js');
var toggleLifeThreatening = require('./toggleDietaryPrefs.js');
var togglePrefClassYear = require('./togglePrefClassYear.js');
var membValidation = require('./validateMemberNumber.js');

(function ($) {
	$(function () {
		if (window.iq.cookie_consent_config) {
			window.cookieconsent.initialise(window.iq.cookie_consent_config);
		}

		if (window.iq.isRegistration) {
			if (!window.iq.allow_back_button) {
				disableBackButton(function onBackButton() {
					window.alert('The back button has been blocked to prevent registration errors.');
				});
			}

			$(document).on('click', '.toggle-help', function (e) {
				e.preventDefault();
				var $clickTarget = $(this);
				$($clickTarget.attr('href')).toggleClass('hide');
				return false;
			});

			onBonusTab(function bonusTabDetected() {
				var language =
					'<strong>Multiple Sessions Warning:</strong> To prevent errors, it is recommended that you close all but one registration browser tab';
				var divstyles =
					'background-color:red;position:fixed;top:0;width:100%;height:40px;text-align:center;z-index:1000;';
				var warning = $(
					'<div id="multiTabWarning" style="' +
						divstyles +
						'"><p style="color:white;margin: 0;padding-top: 10px;">' +
						language +
						'</p></div>'
				);
				$('body').append(warning);
				$('body').css('padding-top', '40px');
			});

			if (window.iq.detect_afk) {
				onMinutesAFK(30, function afkHandler() {
					window.alert(
						'It looks like you stepped away from your registration for quite a while. Not to worry, we saved your work! We just need to refresh the page so that you can continue.'
					);
					document.location.reload();
				});
			}

			$(function () {
				$('.iq-fade-in').addClass('in');

				$('.confirm-link-click').on('click', function (e) {
					e.preventDefault();

					var next_url = $(this).attr('href');
					if (confirm('Are you sure you want to start over?')) {
						return (window.location.href = next_url);
					}

					return false;
				});

				$('#decline-form').on('submit', function (e) {
					if ($('#decline-form #declineFirstName').length > 0) {
						// only need to validate if it's a manual form fill
						validateEmail(
							'#declineEmailAddress',
							'isValidEmail',
							'#decline-form',
							$('#decline-form button[type=submit]'),
							() => {
								window.alert('Email address is invalid');
							}
						);

						var error = false;
						error = validate_textfield('.isRequired') || error;
						if (error) {
							$('.error').on('click keyup', '.isRequired', function () {
								validate_textfield('.isRequired');
							});
							window.alert('Please make a selection in all fields marked in red');
							reEnableSubmit();
						}

						if (error) {
							return false;
						}
					}
					return true;
				});
			});

			//make sure the dropdown is correctly toggled according to page-load checkbox statuses
			//when personType checkboxes change, toggle the prefClassYear dropdown
			// 👇 This one is for the primary
			$('input[type=checkbox][name=personType]').change(function onPersonTypeChange() {
				togglePrefClassYear();
			});
			// 👇 This one is for edits and guest creation
			$('#party-container').on('change', 'input[type=checkbox][name=personType]', function onPersonTypeChange() {
				togglePrefClassYear();
			});
			togglePrefClassYear();

			// when isretired is changed, make sure you clear/set required state on employer and title fields
			$('#party-container').on('change', 'input[type=checkbox][name=isretired]', function onRetiredChange() {
				toggleRetired();
			});

			dietaryPrefs();

			toggleRetired();

			if ($('.preventMultipleSubmit').length > 0) {
				//disableMultipleSubmit( formSelector, btnSelector )
				var reEnableSubmit = disableMultipleSubmit('form.preventMultipleSubmit', 'button.preventMultipleSubmit');
			}

			//this way, if the field is hidden because of the feature flag, it won't cause JS errors
			const requireAcceptPrivacyPolicy = $('#acceptPrivacyPolicy').length > 0;

			var validateForm = function () {
				var error = false;
				error = validate_textfield('.isRequired') || error;
				error = validate_cb_1ormore('#personType input[type=checkbox]') || error;
				if (requireAcceptPrivacyPolicy) {
					error = validate_cb_1ormore('#acceptPrivacyPolicy') || error;
				}
				error = validatePhoneNumber('#phoneNumber') || error;
				error = !membValidation.isMemberNumberValid() || error;

				if (error) {
					$('.error').on('click keyup', '#personType,.isRequired,#phoneNumber,#acceptPrivacyPolicy', function () {
						validate_textfield('.isRequired');
						validate_cb_1ormore('#personType input[type=checkbox]');
						validatePhoneNumber('#phoneNumber');
						if (requireAcceptPrivacyPolicy) {
							validate_cb_1ormore('#acceptPrivacyPolicy');
						}
					});
					window.alert('Please make a selection in all fields marked in red');
					reEnableSubmit();
				}
				return error;
			};

			if ($('#primary').length > 0) {
				//on primary registrant screen
				enableExpansion(document);

				$('#memberNumber').on('change keyup', membValidation.validateMemberNumber);
				$('#lastName').on('change keyup', membValidation.validateMemberNumber);
				$('#maidenName').on('change keyup', membValidation.validateMemberNumber);
				$('.personType').on('change', toggleAssociatedStudentFields);
				$('#primary').on('submit', function () {
					if (
						$('#memberNumber').length === 1 &&
						$('#memberNumber').hasClass('required') &&
						$('#memberNumber').val().length === 0
					) {
						window.alert('This event is for members only; please input a valid member number.');
						reEnableSubmit();
						return false;
					}

					if (
						validateEmail('#email', 'isValidEmail', '#primary', $('#primary button[type=submit]'), () => {
							window.alert('Email address is invalid');
						})
					) {
						return !validateForm();
					} else {
						return false;
					}
				});

				if ($('#phoneNumber').is(':visible')) {
					phone_utils.setup_intl_tel_input(
						'#phoneNumber',
						'#phoneNumberValue',
						'#phoneDialCodeValue',
						'#phoneCountryCodeValue'
					);
				}

				//$('#phoneNumber').keyup(); // trigger the field set
				membValidation.validateMemberNumber();
			}

			if ($('#party-container').length > 0) {
				$('#party-container').on('submit', 'form', partyMembers.validate);

				var guestSearcher = (function () {
					var xhr; //enables canceling in-progress requests when a new one comes along

					return _.debounce(function searchGuest() {
						var $throbber = $('#throbber');
						var $searchResult = $('#searchResult');
						var query = $(this).val();
						$throbber.show();

						if (xhr && xhr.readyState !== 4) {
							xhr.abort();
						}

						xhr = window.jQuery
							.getJSON(
								base + '/events:register/searchguest',
								{
									email: query
								},
								function jsonLoaded(data) {
									$throbber.hide();
									if (!data.hasOwnProperty('prefix')) {
										$searchResult
											.html(
												$(
													"<hr style='margin:20px 0'/><p align='center'>No results (You must provide the full email address)</p>"
												)
											)
											.slideDown('slow');
										return;
									}
									var content = `<hr style="margin:20px 0"/>
								<div class="col-sm-3">
									<strong>We found:</strong>
								</div>
								<div class="col-sm-6">
									${data.prefix} ${data.fname} ${data.nickname.length > 0 ? '"' + data.nickname + '"' : ''} ${data.lname} ${
										data.gradLastName.length > 0 ? '(' + data.gradLastName + ')' : ''
									} ${data.prefClassYear !== '' ? ', Class of ' + data.prefClassYear : ''}
								</div>
								<div class="col-sm-3">
									<button type="button" class="btn btn-success btn-sm prefillPerson">
										<i class="fa fa-thumbs-o-up"></i> Use this person
									</button>
								</div>`;
									$searchResult.html(content).data('result', data).slideDown('slow');
								}
							)
							.fail(function searchError(jqxhr, textStatus, error) {
								if (jqxhr.readyState == 4) {
									if (console) {
										console.error(textStatus, error, jqxhr);
									}
									$throbber.hide();
									$searchResult
										.html(
											$(
												"<div class='alert alert-warning'>Something broke while we were searching for your guest. Sorry about that! You may have to enter their details manually.</div>"
											)
										)
										.slideDown('slow');
								}
							});
					}, 250);
				})();

				var afterGuestFormLoaded = function () {
					enableExpansion('#party-container');
					toggleChildFields('#party-container');

					//make edits to one affect the other too
					bindTextInputs('#email', '#email2');

					$('#memberNumber').on('change keyup', partyMembers.validateMemberNumber);
					$('#lastName').on('change keyup', partyMembers.validateMemberNumber);
					$('#maidenName').on('change keyup', partyMembers.validateMemberNumber);

					$('.personType').closest('form').on('submit', partyMembers.validate);
					$('.personType').on('change', toggleAssociatedStudentFields);

					if ($('#phoneNumber').is(':visible')) {
						phone_utils.setup_intl_tel_input(
							'#phoneNumber',
							'#phoneNumberValue',
							'#phoneDialCodeValue',
							'#phoneCountryCodeValue'
						);
					}
				};

				var toggleAssociatedStudentFields = function () {
					var selectedAffiliationTypes = $('input[name=personType]:checked');
					var enableRelationshipToStudent = true;

					selectedAffiliationTypes.each(function () {
						if ($(this).data('apialias') === 'isStudent') {
							// students can't have a relationship to themselves. see a therapist instead.
							enableRelationshipToStudent = false;
						}
					});

					if (enableRelationshipToStudent) {
						$('#relationshipToStudentWrap').show();
						$('#associatedStudent').show();
					} else {
						$('#relationshipToStudentWrap').hide();
						$('#associatedStudent').hide();
					}
				};

				var TCF = function () {
					toggleChildFields('#party-container');
				};
				$('#party-container')
					.click('input[name=isMinor]', TCF)
					.click('#saveFreqFlyer', partyMembers.toggleFF)
					.click('#saveFreqFlyer', TCF)
					.click('input[name=dietaryNeeds]', toggleLifeThreatening)
					.on('keyup change', '#email', guestSearcher);
				$('.editPerson').click(function onEditPersonClick() {
					var reservationId = $('#party').data('reservation');
					var personId = $(this).data('personid');
					var eventId = $('#party').data('eventid');
					$('#party-container').html(
						'<p align="center" style="margin-top: 100px; margin-bottom: 30px;"><i class="fa fa-cog fa-spin fa-5x"></i><br/>Loading</p>'
					);
					$('#party-container').load(
						base + '/events:register/editguest/resGuid/' + reservationId + '/personId/' + personId,
						{},
						function (response, status, xhr) {
							if (status == 'error') {
								var msg = 'Sorry, there was an error: ';
								alert(msg + 'You cannot edit a person that is not in the party.');
								var url = base + '/events:register/party/reservation/';
								url += reservationId + '/eventId/' + eventId;
								window.location.href = url;
							} else {
								afterGuestFormLoaded();
							}
						}
					);
				});

				$('.person-add').click(function onAddFreqFlyerClick() {
					var $modal = $('#addPerson');
					var hasFF = $modal.data('hasff');

					if (hasFF) {
						$modal.modal('show');
					} else {
						$('.addPerson').click();
					}
				});
				$('.ff-selector').on('click', function onFFCheck() {
					var maxGuests = $('.addFF').data('maxguests');
					var currentGuests = $('.addFF').data('guestcount');
					var addFFcount = $('.ff-selector:checked').length;

					maxGuests = maxGuests === '' ? Infinity : maxGuests;
					var limitReached = currentGuests + addFFcount >= maxGuests;

					if (limitReached) {
						$('#guestLimitWarning').removeClass('hide');
						$('.ff-selector').not(':checked').attr('disabled', 'disabled').closest('label').addClass('disabled');
					} else {
						$('#guestLimitWarning').addClass('hide');
						$('.ff-selector').removeAttr('disabled').closest('label').removeClass('disabled');
					}

					if (addFFcount > 0) {
						$('#submitAddFF').removeClass('disabled');
					} else {
						$('#submitAddFF').addClass('disabled');
					}
				});

				$('#event-reg').on('click', '.addPerson', function onAddPersonClick() {
					var reservationId = $('#party').data('reservation');
					$('#party-container').html(
						'<p align="center" style="margin-top: 100px; margin-bottom: 30px;"><i class="fa fa-cog fa-spin fa-5x"></i><br/>Loading</p>'
					);
					$('#party-container').load(
						base + '/events:register/editguest/resGuid/' + reservationId,
						afterGuestFormLoaded
					);
					$('#addPerson').modal('hide');
				});

				$('#party-container').on('click', '.prefillPerson', function () {
					var $sr = $('#searchResult');
					$sr.slideUp('fast');
					var person = $sr.data('result');

					$('#xid').val(person.xid);
					if (person.prefix !== '') {
						$('#prefix').val(person.prefix);
					}
					if (person.fname !== '') {
						$('#firstName').val(person.fname);
					}
					if (person.nickname !== '') {
						$('#badgeName').val(person.nickname);
					}
					if (person.lname !== '') {
						$('#lastName').val(person.lname);
					}
					if (person.suffix !== '') {
						$('#name_suffix').val(person.suffix);
					}
					if (person.gradLastName !== '') {
						$('#maidenName').val(person.gradLastName);
					}
					if (person.prefClassYear !== '') {
						$('#preferredClassYear').val(person.prefClassYear);
					}
					if (person.phone !== '') {
						$('#phoneNumber').val(person.phone);
					}
					if (person.phoneType !== '') {
						$('#phoneNumberType').val(person.phoneType);
					}
				});
			}

			if ($('#partyMemberSelections').length > 0) {
				enableExpansion('#partyMemberSelections');
				$('#partyMemberSelections').data('reenable', reEnableSubmit).submit(selections.validateActivitySelections);
				$('#partyMemberSelections select').on('change', selections.calculateSubtotal);
				$('#partyMemberSelections select.primary').on('change', function onPartySelectChange() {
					// deal with mutexes
					if ($(this).val() != '' && $(this).val() != 0 && $(this).val() != 'false') {
						// hold ref to the one we're working on
						var mark = $(this);
						var markval = mark.val();

						// mutex handler: any other data-mutex value = this one, zero out those others and pop alert
						var mutexFired = false;
						if (mark.data('mutex') != undefined && mark.data('mutex') != '') {
							var mx = mark.data('mutex');
							var container = $('#partyMemberSelections');
							container.find("[data-mutex='" + mx + "']").each(function () {
								mutexFired = true;

								$(this).val('false').trigger('change');
							});
						}

						mark.val(markval);
					}
					selections.enableSectionsOptions(this);
					selections.calculateSubtotal();
				});
				$('#partyMemberSelections select.primary').each(function forEachPartySelect() {
					selections.enableSectionsOptions(this);
				});
				selections.calculateSubtotal();
			}

			$('.confirmPackagesSelected').on('click', function onConfirmPackagesClick() {
				if ($('#partyPackageSummary').find('.btn-primary').length > 0) {
					window.alert('You must make package selections for everyone in your party before you may continue');
					return false;
				}
				return true;
			});

			if ($('#regInvoice').length > 0) {
				//on invoice screen
				const schoolUsesCashnet = $('#regInvoice').hasClass('cashnet');

				enableExpansion(document);
				invoice.init();
				invoice.configureDesignationSearch();
				invoice.handleGiftChange();

				window.jQuery('#discountAttempt').on('shown.bs.modal', function () {
					// when we open the modal reset to decent state
					window.jQuery('#discountCode').val('');
					window.jQuery('#dcForm').show();
					window.jQuery('#dcMessage').html('').hide();
					window.jQuery('#dcMultiForm').hide();
				});

				$('#discountCodeCheck').on('click', function (e) {
					e.preventDefault();

					var eid = window.jQuery('#eventId').val();
					var pid = window.jQuery('#pid').val();
					var discountCode = window.jQuery('#discountCode').val();

					if (window.jQuery.trim(discountCode) == '') {
						window
							.jQuery('#dcMessage')
							.addClass('alert-danger')
							.removeClass('alert-info')
							.html('<p>Please provide a discount code.</p>')
							.show();
						return;
					}

					window
						.jQuery('#dcMessage')
						.removeClass('alert-danger')
						.addClass('alert-info')
						.html('<p><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i></p><p>Validating discount code...</p>')
						.show();

					window.jQuery.post(
						'/index.cfm/events:register/validateDiscountCode',
						{
							eventid: eid,
							pid: pid,
							discountCode: discountCode
						},
						function (response) {
							// response always contains a 'valid' boolean
							if (response.valid) {
								console.log(response.aFees.length);
								if (response.aFees.length == 1) {
									// only one discounted applicable fee, so apply it and refresh the screen
									window.jQuery('#dcForm').hide();
									window
										.jQuery('#dcMessage')
										.html('<p><i class="fa fa-spinner fa-pulse fa-fw"></i> Applying discount...</p>')
										.show();
									window.jQuery.post(
										'/index.cfm/events:register/applyDiscountCodeFee',
										{
											regInProgressPersonId: pid,
											activityFeeId: response.aFees[0].activityFeeId,
											discountCode: discountCode
										},
										function () {
											window.location.reload();
										}
									);
								} else {
									// multiple fees - expose a dropdown to choose
									window.jQuery('#dcForm').hide();
									window.jQuery('#dcMultiForm').hide();
									window.jQuery('#dcMessage').html('').hide();
									// remove all prior options
									window.jQuery('#afid').find('option').remove();
									// append new options and reveal form
									$.each(response.aFees, function (i, fee) {
										window.jQuery('#afid').append(
											$('<option>', {
												value: fee.activityFeeId,
												text: fee.name + ' ($' + fee.feeDollars + ')'
											})
										);
									});
									window.jQuery('#dcMultiForm').show();
									window.jQuery('#discountCodeApply').on('click', function () {
										e.preventDefault();
										window.jQuery('#dcMultiForm').hide();
										window
											.jQuery('#dcMessage')
											.html('<p><i class="fa fa-spinner fa-pulse fa-fw"></i> Applying discount...</p>')
											.show();
										window.jQuery.post(
											'/index.cfm/events:register/applyDiscountCodeFee',
											{
												regInProgressPersonId: pid,
												activityFeeId: window.jQuery('#afid').val(),
												discountCode: discountCode
											},
											function () {
												window.location.reload();
											}
										);
									});
								}
							} else {
								// if not valid, we are also nice enough to tell you why
								window
									.jQuery('#dcMessage')
									.removeClass('alert-info')
									.addClass('alert-danger')
									.html('<i class="fa fa-thumbs-down" aria-hidden="true"></i> ' + response.message)
									.show();
							}
						}
					);
				});

				$('.nacheck').on('click', function () {
					let target = $(this).data('associatedinput');
					target = $('#' + target);

					if ($(this).is(':checked')) {
						target.val('~N/A~');
						target.prop('readonly', true);
					} else {
						target.val('');
						target.prop('readonly', false);
					}
				});

				$('#giftDollars').on('change', invoice.handleGiftChange);
				$('#regInvoice')
					.data('reenable', reEnableSubmit)
					.on('submit', function (e) {
						var error = validateForm();

						error = validate_cb_1ormore('.requireRadio, .requireCheckbox') || error;
						error = validate_textfield('.requireText') || error;

						if (error) {
							reEnableSubmit();
							return false;
						}

						if (!schoolUsesCashnet) {
							processCharge(e);
						}
					});

				if (schoolUsesCashnet) {
					//cashnet
				} else {
					//spreedly and braintree
					invoice.initGateway(parseFloat($('#chargeAmount').val() || '0'));
				}
			}

			if ($('#confInvoice').length > 0) {
				$('#confInvoice')
					.data('reenable', reEnableSubmit)
					.on('submit', function (e) {
						var error = validateForm();

						if (error) {
							return false;
						}

						processCharge(e);
					});

				invoice.initGateway(parseFloat($('#chargeAmount').val() || '0'));

				$('.address-wrapper #address1').on('change', handleAddressField('address1'));
				$('.address-wrapper #address2').on('change', handleAddressField('address2'));
				$('.address-wrapper #city').on('change', handleAddressField('city'));
				$('.address-wrapper #state').on('change', handleAddressField('state'));
				$('.address-wrapper #postalCode').on('change', handleAddressField('postalCode'));
				$('.address-wrapper #nation').on('change', handleAddressField('country'));
				$('.address-wrapper #isUpdatedAddress').on('change', handleAddressField('isUpdatedAddress'));
				$('.address-wrapper #addrType').on('change', handleAddressField('addrType'));
			}
		}

		function processCharge(e) {
			if ($('#chargeAmount').val() > 0 && $('#paymentToken').val().trim() === '') {
				e.preventDefault();
				if (invoice.validate()) {
					invoice.tokenizePayment();
					// $('#spreedly-modal-overlay').css('position', 'fixed').css('top', 0).css('left', 0);
					return false;
				}
			} else {
				invoice.validate();
			}
		}

		function handleAddressField(window_iq_prop) {
			return function (e) {
				window.iq[window_iq_prop] = e.target.value;
				$('#confInvoice #' + window_iq_prop).val(e.target.value);
			};
		}
	});
})(window.jQuery);
